export default "__VITE_ASSET__4oal$GRE__"